import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { AccessProvider } from "./access";

ReactDOM.render(
  <React.StrictMode>
    <AccessProvider>
      <App />
    </AccessProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
